import Enum from '@square/dashboard-utilities/utils/enum';
export default new Enum(['FREQUENT_VISITORS', 'HIGH_SPENDERS', 'RECENT_PURCHASERS', 'LOYALTY_MEMBERS']);